import { getTrackingId } from "./track";
import axiosResiInstance from "../http/axiosResi";

export const shareListing = async (data) => {
    const trackingId = await getTrackingId();

    if (trackingId) {
        data.tracking_id = trackingId;
    }

    return axiosResiInstance.post(`/share-listing`, data);
};

export const shareProperty = async (data) => {
    const trackingId = await getTrackingId();

    if (trackingId) {
        data.tracking_id = trackingId;
    }

    return axiosResiInstance.post(`/share-property`, data);
};

export const shareLink = async (listing, property) => {
    const trackingId = await getTrackingId();

    let data = {};

    if (listing) {
        data.listing = listing.id;
    }

    if (property) {
        data.property = property.url;
    }

    if (trackingId) {
        data.tracking_id = trackingId;
    }

    return axiosResiInstance.post(`/share-link`, data);
};
